/**
 * Update date: 14-06-2023
 * Template hyperlink component
 */
import React, { useState } from 'react';
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import useDictionary from 'hooks/useDictionary';

const HyperLink = (props: any) => {
  const { data } = props;
  const { editorOptions } = data;
  const { value, onChangeValue } = editorOptions;
  const [isEdit, setIsEdit] = useState(false);
  const [urlValue, setUrlValue] = useState(value);
  const { t } = useDictionary({});

  /**
   * render link
   *
   * @return {*}
   */
  const renderLink = () => {
    return (
      <div
        style={{
          marginRight: 10,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {value ? (
          <a
            target="_blank"
            href={value}
            rel="noreferrer"
            style={{ wordBreak: 'break-word' }}
          >
            {value}
          </a>
        ) : (
          <div>{t('No Link')}</div>
        )}
        <Button
          style={{ width: 40, marginLeft: 10 }}
          icon="edit"
          onClick={() => setIsEdit(true)}
        />
      </div>
    );
  };

  /**
   * on change value
   *
   * @param {*} e
   */
  const changeValue = (e: any) => {
    setUrlValue(e.value);
    onChangeValue(e.value);
    setIsEdit(false);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      {isEdit ? (
        <TextBox
          style={{ flex: 1 }}
          defaultValue={urlValue}
          onValueChanged={changeValue}
        />
      ) : (
        renderLink()
      )}
    </div>
  );
};

export default HyperLink;
